import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Badge, TextStyle } from '@superops/ui-design-system';
import { STATUS_MAP } from '@nile/projects/src/Constants';

const BadgeCell = (props) => {
  const cell = props?.cell;
  const value = cell?.value;
  const accessorKey = cell?.column?.accessorKey;
  const fieldOptions = cell?.column?.fieldOptions;
  const currentValue = fieldOptions?.find((field) => field?.id === value);
  const getStatus = () => {
    return STATUS_MAP?.[accessorKey]?.[currentValue?.id];
  };
  const status = getStatus() || 'info';

  if (!value) {
    return <TextStyle variation="subdued">NA</TextStyle>;
  }
  return (
    <Badge status={status}>
      <TextStyle>
        <FormattedMessage id={value} />
      </TextStyle>
    </Badge>
  );
};

export default BadgeCell;
